skrilla.controller('playerDetailsCtrl', function ($scope, searchService, $stateParams, modalService, cacheService, srefService, dataService, queryService, envService, countryService) {
    $scope.validate = {}

    $scope.countries = countryService.getAllCountries()

    searchService.get("players/" + $stateParams.id).then(function(response){
        $scope.player = response.data;
        const split = $scope.player.name.split(", ");
        $scope.player.lastName = split[0];
        $scope.player.firstName = split[1];
    })

    $scope.changeFranchise = function(){
        srefService.go("franchiseDetails", {id: $scope.player.franchiseId});
    }

    $scope.save = function(){
        if(dataService.validatePlayer($scope.player, $scope.validate)) {
            $scope.player.name = $scope.player.firstName ? $scope.player.lastName + ", " + $scope.player.firstName : $scope.player.lastName;
            $scope.player.nickname = $scope.player.nickName;
            modalService.confirm("Are you sure you'd like to update this player?", function () {
                searchService.put("players/" + $scope.player.sport + "/" + $scope.player.id, $scope.player, "Successfully updated").then(function (response) {

                });
            });
        }
    }

    $scope.changeActive = function(){
        modalService.confirm("Are you sure you'd like to change this player's active status?", function(){
            var method = $scope.player.active ?  "deleteRequest" : "post";
            searchService[method]("players/" + $scope.player.sport + "/" + $scope.player.id + "/active").then(function(response){
                swal("Success", "Player successfully updated")
                $scope.player.active = !$scope.player.active;
            });
        });

    }
    $scope.merge = function(){
            cacheService.registerObject("player", $scope.player);
            modalService.openModal("views/mergePlayerModal/mergePlayerModal.html", true, 'lg', true, true);
    }

    //Pre load the widget so user doesn't have to wait
    const createMediaLibrary = function (envService, $scope) {
        if ($scope.mediaLibraryWidget) {
            return $scope.mediaLibraryWidget;
        }
        if (typeof cloudinary === 'undefined') {
            console.log("Cloudinary not available")
            return
        }

        $scope.mediaLibraryWidget = cloudinary.createMediaLibrary({
              ...envService.read('cloudinary'),
              multiple: false,
              max_files: 1
          }, {
              insertHandler: function (data) {
                  data.assets.forEach(asset => {
                      $scope.$apply(() => {
                          if (asset.derived && asset.derived.length > 0) {
                              $scope.player.avatarUri = asset.derived[0].secure_url;
                          } else {
                              $scope.player.avatarUri = asset.secure_url;
                          }
                      })
                  })
              }
          }
        );
        return $scope.mediaLibraryWidget;
    };

    createMediaLibrary(envService, $scope);

    $scope.openLibraryWidget = function() {
        createMediaLibrary(envService, $scope).show({
            folder: {resource_type: "image"},
        });
    }
});
